// Tour data structure for the React app
export const trekkingTours = [
  {
    id: 'valley-of-flowers',
    name: "Valley of Flowers Trek",
    duration: "05 Nights 06 Days",
    price: "₹ 8,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935182/qjoodhhsw4zukjx801pd.jpg",
    link: "/valley-of-flowers",
    altitude: "3,858 ft",
    difficulty: "Moderate",
    category: "trekking",
    region: "Uttarakhand",
    highlights: ["Alpine meadows", "Rare flowers", "Snow-capped peaks"],
    bestTime: "July to September"
  },
  {
    id: 'sar-pass',
    name: "Sar Pass Trek",
    duration: "04 Nights 05 Days",
    price: "₹ 4,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935181/fkrfan4lfb0dcod97anh.jpg",
    link: "/sar-pass-trek",
    altitude: "13,800 ft",
    difficulty: "Moderate",
    category: "trekking",
    region: "Himachal Pradesh",
    highlights: ["Mountain pass", "Alpine lakes", "Panoramic views"],
    bestTime: "May to October"
  },
  {
    id: 'kedarkantha',
    name: "Kedarkantha Trek",
    duration: "04 Nights 05 Days",
    price: "₹ 4,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935181/aavzpyu1xwmalssimnfa.webp",
    link: "/kedarkantha-trek",
    altitude: "12,500 ft",
    difficulty: "Easy-Moderate",
    category: "trekking",
    region: "Uttarakhand",
    highlights: ["Winter trek", "Summit views", "Forest trails"],
    bestTime: "December to April"
  },
  {
    id: 'kuari-pass',
    name: "Kuari Pass Trek",
    duration: "04 Nights 05 Days",
    price: "₹ 6,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935181/wrfiog0aowtrhxr4dz7n.jpg",
    link: "/kuari-pass-trek",
    altitude: "13,900 ft",
    difficulty: "Moderate",
    category: "trekking",
    region: "Uttarakhand",
    highlights: ["Ancient route", "Mountain passes", "Sacred sites"],
    bestTime: "March to June, September to November"
  },
  {
    id: 'kashmir-great-lakes',
    name: "Kashmir Great Lakes Trek",
    duration: "06 Nights 07 Days",
    price: "₹ 14,499/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935853/wpeeo9yz50b5lkahjf5w.jpg",
    link: "/kashmir-great-lake-trek",
    altitude: "13,000 ft",
    difficulty: "Moderate to Difficult",
    category: "trekking",
    region: "Jammu & Kashmir",
    highlights: ["Alpine lakes", "Meadows", "Snow peaks"],
    bestTime: "July to September"
  },
  {
    id: 'kareri-lake',
    name: "Kareri Lake Trek",
    duration: "01 Night 02 Days",
    price: "₹ 2,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935184/jspxf8dai06b00xoyevu.webp",
    link: "/kareri-lake-trek",
    altitude: "9,650 ft",
    difficulty: "Easy to Moderate",
    category: "trekking",
    region: "Himachal Pradesh",
    highlights: ["High-altitude lake", "Weekend trek", "Scenic beauty"],
    bestTime: "May to October"
  },
  {
    id: 'parashar-lake',
    name: "Parashar Lake Trek",
    duration: "01 Night 02 Days",
    price: "₹ 2,499/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935182/a1xo4ziayszs7vli9mgy.jpg",
    link: "/parashar-lake-trek",
    altitude: "8,956 ft",
    difficulty: "Easy to Moderate",
    category: "trekking",
    region: "Himachal Pradesh",
    highlights: ["Sacred lake", "Temple", "Weekend getaway"],
    bestTime: "March to November"
  },
  {
    id: 'har-ki-dun',
    name: "Har ki Dun Trek",
    duration: "06 Nights 07 Days",
    price: "₹ 7,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935181/i9d3w6xabdgelkzseik6.jpg",
    link: "/har-ki-dun-trek",
    altitude: "11,675 ft",
    difficulty: "Moderate",
    category: "trekking",
    region: "Uttarakhand",
    highlights: ["Valley trek", "Ancient route", "Cultural villages"],
    bestTime: "March to June, September to November"
  },
  {
    id: 'hampta-pass',
    name: "Hampta Pass Trek",
    duration: "04 Nights 05 Days",
    price: "₹ 4,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935183/khgpbg3twluagvqaqwi4.avif",
    link: "/hampta-pass-trek",
    altitude: "14,200 ft",
    difficulty: "Easy to Moderate",
    category: "trekking",
    region: "Himachal Pradesh",
    highlights: ["Cross-country trek", "Alpine meadows", "River crossings"],
    bestTime: "June to October"
  },
  {
    id: 'dayara-bugyal',
    name: "Dayara Bugyal Trek",
    duration: "03 Nights 04 Days",
    price: "₹ 5,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935198/thfz6pxxfavwgzoixjqo.jpg",
    link: "/dayara-bugyal-trek",
    altitude: "11,600 ft",
    difficulty: "Easy",
    category: "trekking",
    region: "Uttarakhand",
    highlights: ["Alpine meadows", "Family trek", "Scenic beauty"],
    bestTime: "May to November"
  },
  {
    id: 'bhrigu-lake',
    name: "Bhrigu Lake Trek",
    duration: "03 Nights 04 Days",
    price: "₹ 4,499/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935854/vvsalykumt9kuklieib9.webp",
    link: "/bhrigu-lake-trek",
    altitude: "14,000 ft",
    difficulty: "Easy to Moderate",
    category: "trekking",
    region: "Himachal Pradesh",
    highlights: ["High-altitude lake", "Mountain views", "Alpine meadows"],
    bestTime: "May to October"
  },
  {
    id: 'brahmatal',
    name: "Brahmatal Trek",
    duration: "05 Nights 06 Days",
    price: "₹ 5,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935197/k4vfrhgmwr5efnqecus8.jpg",
    link: "/brahmatal-trek",
    altitude: "12,100 ft",
    difficulty: "Moderate",
    category: "trekking",
    region: "Uttarakhand",
    highlights: ["Winter trek", "Snow-covered trails", "Mountain views"],
    bestTime: "December to March"
  },
  {
    id: 'nag-tibba',
    name: "Nag Tibba Trek",
    duration: "01 Nights 02 Days",
    price: "₹ 1,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935853/paosdyxmrcnhcpujwd85.webp",
    link: "/nag-tibba-trek",
    altitude: "9,915 ft",
    difficulty: "Easy",
    category: "trekking",
    region: "Uttarakhand",
    highlights: ["Weekend trek", "Summit views", "Forest trails"],
    bestTime: "October to June"
  },
  {
    id: 'gaumukh-tapovan',
    name: "Gaumukh Tapovan Trek",
    duration: "05 Nights 06 Days",
    price: "₹ 11,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935180/jia7peu1ixqjpom8thm8.webp",
    link: "/gaumukh-tapovan-trek",
    altitude: "14,600 ft",
    difficulty: "Difficult",
    category: "trekking",
    region: "Uttarakhand",
    highlights: ["Gangotri glacier", "Sacred site", "High altitude"],
    bestTime: "May to October"
  },
  {
    id: 'beas-kund',
    name: "Beas Kund Trek",
    duration: "04 Nights 05 Days",
    price: "₹ 4,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935198/uzuo6rxsy5i5yk5ca3ck.webp",
    link: "/beas-kund-trek",
    altitude: "12,139 ft",
    difficulty: "Moderate",
    category: "trekking",
    region: "Himachal Pradesh",
    highlights: ["Sacred lake", "Mountain views", "Alpine meadows"],
    bestTime: "May to October"
  },
  {
    id: 'bunbuni-pass',
    name: "Bunbuni Pass Trek",
    duration: "03 Nights 04 Days",
    price: "₹ 4,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935854/vejvflj60hqcacq9etey.jpg",
    link: "/bunbuni-pass-trek",
    altitude: "9,700 ft",
    difficulty: "Moderate",
    category: "trekking",
    region: "Himachal Pradesh",
    highlights: ["Mountain pass", "Forest trails", "Scenic views"],
    bestTime: "April to November"
  },
  {
    id: 'phulara-ridge',
    name: "Phulara Ridge Trek",
    duration: "04 Nights 05 Days",
    price: "₹ 6,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754936217/ehn89o0kdioigrpwf4bi.jpg",
    link: "/phulara-ridge-trek",
    altitude: "12,000 ft",
    difficulty: "Moderate",
    category: "trekking",
    region: "Uttarakhand",
    highlights: ["Ridge walk", "Meadow views", "Mountain panoramas"],
    bestTime: "May to October"
  },
  {
    id: 'chopta-tungnath',
    name: "Chopta Tungnath Trek",
    duration: "02 Nights 03 Days",
    price: "₹ 4,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754934084/hua4lwsxtzobrjkxqorr.webp",
    link: "/chopta-tungnath-trek",
    altitude: "12,073 ft",
    difficulty: "Easy",
    category: "trekking",
    region: "Uttarakhand",
    highlights: ["Sacred temple", "Mountain views", "Weekend trek"],
    bestTime: "March to November"
  },
  {
    id: 'manali-kasol',
    name: "Manali and Kasol",
    duration: "06 Nights 07 Days",
    price: "₹ 5,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935854/vd5hkycxxmpaejipn0ow.jpg",
    link: "/manali-kasol-tour",
    altitude: "5,180 ft",
    difficulty: "Easy",
    category: "trekking",
    region: "Himachal Pradesh",
    highlights: ["Mountain towns", "Cultural experience", "Scenic beauty"],
    bestTime: "March to November"
  },
  {
    id: 'bali-pass',
    name: "Bali Pass Trek",
    duration: "07 Nights 08 Days",
    price: "₹ 18,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935855/nw18bwxvx2qhtvpiwim9.webp",
    link: "/bali-pass-trek",
    altitude: "16,000 ft",
    difficulty: "Difficult",
    category: "trekking",
    region: "Uttarakhand",
    highlights: ["High altitude", "Challenging trek", "Mountain views"],
    bestTime: "May to October"
  },
  {
    id: 'buran-ghati',
    name: "Buran Ghati Trek",
    duration: "06 Nights 07 Days",
    price: "₹ 13,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935197/a5d4b1bdzzkd9nuns9zt.jpg",
    link: "/buran-ghati-trek",
    altitude: "15,000 ft",
    difficulty: "Moderate",
    category: "trekking",
    region: "Himachal Pradesh",
    highlights: ["High altitude", "Mountain pass", "Alpine scenery"],
    bestTime: "June to September"
  }
];

export const destinations = [
  {
    id: 'spiti-valley',
    name: 'Spiti Valley',
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1755000420/muw23asrqefdeozseolq.jpg?v=2",
    link: "/spiti-valley",
    places: 1,
    category: "backpacking",
    region: "Himachal Pradesh",
    description: "A high-altitude desert valley known for its stunning landscapes and ancient monasteries"
  },
  {
    id: 'meghalaya',
    name: 'Meghalaya',
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1755000311/qmgldyf6dkmqdkaqtd7s.jpg?v=2",
    link: "/meghalaya",
    places: 1,
    category: "backpacking",
    region: "North East",
    description: "The abode of clouds with living root bridges and pristine waterfalls"
  },
  {
    id: 'leh-ladakh',
    name: 'Leh Ladakh',
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754937348/xmwr1mapeail1fus2ayr.jpg?v=2",
    link: "/leh-ladakh",
    places: 4,
    category: "backpacking",
    region: "Ladakh",
    description: "A high-altitude desert with ancient monasteries and breathtaking landscapes"
  },
  {
    id: 'kashmir',
    name: 'Kashmir',
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1755000434/xkaypfvzyqk2ih4djgvz.jpg?v=2",
    link: "/kashmir",
    places: 1,
    category: "backpacking",
    region: "Jammu & Kashmir",
    description: "Paradise on earth with beautiful valleys, lakes, and snow-capped mountains"
  },
  {
    id: 'kerala',
    name: 'Kerala',
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754937347/ez8x79cuswsgt8azvo9k.jpg?v=2",
    link: "/kerala",
    places: 1,
    category: "backpacking",
    region: "South India",
    description: "God's own country with backwaters, beaches, and lush greenery"
  },
  {
    id: 'trekking',
    name: 'Trekking',
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754937894/m0ujhu0afhw3kntzn8a4.jpg?v=2",
    link: "/trekking-tours",
    places: "Multiple Tours",
    category: "trekking",
    region: "Pan India",
    description: "Adventure trekking experiences across the Himalayas"
  }
];

export const weekendTrips = [
  {
    id: 'kanatal-tehri-lake',
    name: 'Kanatal Tehri Lake',
    duration: '1N | 2D',
    category: 'weekend',
    region: 'Uttarakhand',
    link: '/kanatal-tehri-lake',
    image: 'https://res.cloudinary.com/duym2bgp2/image/upload/v1755005553/zw0w4nvg3ygkkjar3fjw.jpg',
    price: '₹ 4,999/-',
    difficulty: 'Easy'
  },
  {
    id: 'chakrata-tiger-waterfall',
    name: 'Chakrata Tiger Waterfall',
    duration: '1N | 2D',
    category: 'weekend',
    region: 'Uttarakhand',
    link: '/chakrata-tiger-waterfall',
    image: 'https://res.cloudinary.com/duym2bgp2/image/upload/v1754935198/thfz6pxxfavwgzoixjqo.jpg',
    price: '₹ 4,999/-',
    difficulty: 'Easy'
  },
  {
    id: 'mukteshwar',
    name: 'Mukteshwar',
    duration: '1N | 2D',
    category: 'weekend',
    region: 'Uttarakhand',
    link: '/mukteshwar',
    image: 'https://res.cloudinary.com/duym2bgp2/image/upload/v1755001521/o5zv6vkc38zkc6uvcwhg.avif',
    price: '₹ 4,999/-',
    difficulty: 'Easy'
  },
  {
    id: 'yulla-kanda',
    name: 'Yulla Kanda',
    duration: '2N | 3D',
    category: 'weekend',
    region: 'Uttarakhand',
    link: '/yulla-kanda',
    image: 'https://res.cloudinary.com/duym2bgp2/image/upload/v1755615432/jwcdntyka58ccbp87rxz.jpg',
    price: '₹ 6,499/-',
    difficulty: 'Moderate'
  },
  {
    id: 'jibhi-tirthan',
    name: 'Jibhi Tirthan',
    duration: '2N | 3D',
    category: 'weekend',
    region: 'Himachal Pradesh',
    link: '/jibhi-tirthan',
    image: 'https://res.cloudinary.com/duym2bgp2/image/upload/v1755110745/q2sak1qmqevwx0igszco.jpg',
    price: '₹ 5,999/-',
    difficulty: 'Easy'
  },
  {
    id: 'jaisalmer',
    name: 'Jaisalmer',
    duration: '2N | 3D',
    category: 'weekend',
    region: 'Rajasthan',
    link: '/jaisalmer',
    image: 'https://res.cloudinary.com/duym2bgp2/image/upload/v1755110804/yw4ceh4zzmqycsqlltnf.jpg',
    price: '₹ 7,499/-',
    difficulty: 'Easy'
  },
  {
    id: 'udaipur',
    name: 'Udaipur',
    duration: '2N | 3D',
    category: 'weekend',
    region: 'Rajasthan',
    link: '/udaipur',
    image: 'https://res.cloudinary.com/duym2bgp2/image/upload/v1755110856/jw3pxzoqcgtejuyvsogx.jpg',
    price: '₹ 5,999/-',
    difficulty: 'Easy'
  },
  {
    id: 'chopta-tungnath',
    name: 'Chopta Tungnath',
    duration: '2N | 3D',
    category: 'weekend',
    region: 'Uttarakhand',
    link: '/chopta-tungnath',
    image: 'https://res.cloudinary.com/duym2bgp2/image/upload/v1754934084/hua4lwsxtzobrjkxqorr.webp',
    price: '₹ 4,999/-',
    difficulty: 'Easy'
  },
  {
    id: 'harshil',
    name: 'Harshil',
    duration: '2N | 3D',
    category: 'weekend',
    region: 'Uttarakhand',
    link: '/harshil',
    image: 'https://res.cloudinary.com/duym2bgp2/image/upload/v1755110919/qkkxb4nwbgdsrgzjubi3.jpg',
    price: '₹ 5,999/-',
    difficulty: 'Easy'
  },
  {
    id: 'mcleodganj-triund',
    name: 'Mcleodganj Bir',
    duration: '2N | 3D',
    category: 'weekend',
    region: 'Himachal Pradesh',
    link: '/mcleodganj-triund',
    image: 'https://res.cloudinary.com/duym2bgp2/image/upload/v1755615428/wrxxewoeatdlq4glhizo.jpg',
    price: '₹ 6,499/-',
    difficulty: 'Easy'
  },
  {
    id: 'churdhar',
    name: 'Churdhar',
    duration: '2N | 3D',
    category: 'weekend',
    region: 'Himachal Pradesh',
    link: '/churdhar',
    image: 'https://res.cloudinary.com/duym2bgp2/image/upload/v1755111158/xkx4mvpknsx4fip3pzdp.webp',
    price: '₹ 5,999/-',
    difficulty: 'Moderate'
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Shreya",
    content: "NomadTrailz made my Spiti trip super fun! The views were amazing, the stays were warm and comfy, and the food was really tasty. The team was very friendly, and the group made the journey extra special. I'd surely tell others to travel with them for a great adventure!",
    rating: 5
  },
  {
    id: 2,
    name: "Geetika",
    content: "My Hampta trek with NomadTrailz was truly unforgettable! The guides were skilled and supportive, the campsites were well managed, and the scenery was simply mesmerizing. The team took great care of our safety and comfort every step of the way.",
    rating: 5
  },
  {
    id: 3,
    name: "Bhawna",
    content: "My Kashmir journey with NomadTrailz was nothing short of wonderful! From the stunning landscapes of Gulmarg to the serene shikara rides on Dal Lake, every moment felt magical. The itinerary was thoughtfully planned, ensuring a perfect balance of adventure and relaxation.",
    rating: 5
  },
  {
    id: 4,
    name: "Priyanka",
    content: "My Chopta–Tungnath adventure with NomadTrailz was truly memorable! The team made sure every detail was taken care of, from safety and comfort to keeping the journey filled with joy and excitement. Along the way, I met amazing fellow travelers who turned the trip into an even more enriching experience.",
    rating: 5
  },
  {
    id: 5,
    name: "Ravi",
    content: "My trekking experience with NomadTrailz was truly wonderful! We had an amazing time throughout the journey. The meals provided were delicious, and the crew members were extremely supportive and friendly. Even the cab drivers showed great cooperation, which made the entire trip smooth and enjoyable.",
    rating: 5
  },
  {
    id: 6,
    name: "Shivangi",
    content: "Choosing NomadTrailz for my solo trip to Jibhi turned out to be the best decision ever! Every detail was handled with care—from safe travel arrangements to mesmerizing views that left me in awe. I connected with wonderful people along the way, felt a strong sense of empowerment, and came back with memories I'll treasure forever.",
    rating: 5
  }
];

export const heroImages = [
  {
    lowQuality: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=40",
    highQuality: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
  },
  {
    lowQuality: "https://images.unsplash.com/photo-1464822759844-d150baec4b8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=40",
    highQuality: "https://images.unsplash.com/photo-1464822759844-d150baec4b8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
  },
  {
    lowQuality: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=40",
    highQuality: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
  },
  {
    lowQuality: "https://res.cloudinary.com/duym2bgp2/image/upload/w_1200,h_675,c_fill,q_40,f_auto/v1754841063/j9yz8rfxpgdvpimwnlun.jpg",
    highQuality: "https://res.cloudinary.com/duym2bgp2/image/upload/w_1920,h_1080,c_fill,q_80,f_auto/v1754841063/j9yz8rfxpgdvpimwnlun.jpg"
  },
  {
    lowQuality: "https://res.cloudinary.com/duym2bgp2/image/upload/w_1200,h_675,c_fill,q_40,f_auto/v1754841062/uwrukgmn0vmjkrxry8od.jpg",
    highQuality: "https://res.cloudinary.com/duym2bgp2/image/upload/w_1920,h_1080,c_fill,q_80,f_auto/v1754841062/uwrukgmn0vmjkrxry8od.jpg"
  },
  {
    lowQuality: "https://res.cloudinary.com/duym2bgp2/image/upload/w_1200,h_675,c_fill,q_40,f_auto/v1754842210/wbkoxqhzz4amgcvklybw.jpg",
    highQuality: "https://res.cloudinary.com/duym2bgp2/image/upload/w_1920,h_1080,c_fill,q_80,f_auto/v1754842210/wbkoxqhzz4amgcvklybw.jpg"
  }
];

export const journeyImages = [
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755008533/aolshuukh9o34joqozte.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615449/t4wwxkszcsdzhjxfa5pr.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615442/dz3knxpn916f64izyxpw.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615440/vqwcztzsyviibqxmvbsd.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615440/xvysv3unut0gzzrayvmz.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615440/youqrjogivggpmqcfpdi.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615438/ahsxqhs1rmx7o7m8h8n0.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615437/vozq25qgfl95duq0tgwv.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615436/nif0zy1cjp4mgwdxlpsy.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615434/ltrhboftg8eeai3hk9sl.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615428/wrxxewoeatdlq4glhizo.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615426/fg5y8davsbnfbr3qeqsq.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615422/rnibsprkwlmikcmpofk4.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615419/vgfca2qbaalo9zvdkvaa.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615419/jntw4jbzzphjhkrhpupl.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615418/etkapeeawvn0yartrtld.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615417/bgleltkvmwtsrtmqbvbp.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615417/cwydruk2hevbpjjo2lb1.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755612637/ogpnzgfvkxeunclfknuc.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615417/vfgwpz6xmevi82n2gsaa.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615416/o5b9nfyhcyly0uv25yvd.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615424/aejbd3kkx0fqynhdyzl1.jpg",
  "https://res.cloudinary.com/duym2bgp2/image/upload/v1755615434/kl65eoutevojguw3pnio.jpg"
];

// Navigation menu structure
export const navigationMenu = [
  {
    title: "Weekend Trips",
    path: "#tours",
    hasDropdown: true,
    submenu: [
      {
        title: "1N | 2D Trips",
        path: "#1n2d",
        hasSubmenu: true,
        items: [
          { name: "Kanatal Tehri Lake", path: "/kanatal-tehri-lake" },
          { name: "Chakrata Tiger Waterfall", path: "/chakrata-tiger-waterfall" },
          { name: "Mukteshwar", path: "/mukteshwar" }
        ]
      },
      {
        title: "2N | 3D Trips",
        path: "#2n3d",
        hasSubmenu: true,
        items: [
          { name: "Yulla Kanda", path: "/yulla-kanda" },
          { name: "Jibhi Tirthan", path: "/jibhi-tirthan" },
          { name: "Jaisalmer", path: "/jaisalmer" },
          { name: "Udaipur", path: "/udaipur" },
          { name: "Chopta Tungnath", path: "/chopta-tungnath" },
          { name: "Harshil", path: "/harsil-valley" },
          { name: "Mcleodganj Bir", path: "/mcleodganj-triund" },
          { name: "Churdhar", path: "/churdhar" }
        ]
      }
    ]
  },
  {
    title: "Backpacking",
    path: "#backpacking",
    hasDropdown: true,
    submenu: [
      { name: "Spiti Valley", path: "/spiti-valley" },
      { name: "Meghalaya", path: "/meghalaya" },
      { name: "Kerala", path: "/kerala" },
      { name: "Leh Ladakh", path: "/leh-ladakh" },
      { name: "Kashmir", path: "/kashmir" }
    ]
  },
  {
    title: "Trekking",
    path: "/trekking-tours",
    hasDropdown: false
  },
  {
    title: "Panch Kailash",
    path: "/panch-kailash",
    hasDropdown: false
  },
  {
    title: "Panch Kedar",
    path: "/panch-kedar",
    hasDropdown: false
  }
];

// Company information
export const companyInfo = {
  name: "NomadTrailz",
  tagline: "Nomads of the Earth",
  phone: "+91-7678501921",
  whatsapp: "+91-7678501921",
  email: "info.nomadtrailz@gmail.com",
  address: "Office Address: 402 Navneet Plaza Old Palasia Near Apna Sweets Indore",
  logo: "https://res.cloudinary.com/duym2bgp2/image/upload/v1757875773/olhz9gh3fdowxvs7pagu.jpg",
  social: {
    whatsapp: "https://wa.me/917678501921?text=Hi! I'm interested in booking a trip with NomadTrailz. Can you please provide me with more information?",
    instagram: "https://www.instagram.com/nomadtrailz?igsh=ZDBlZmNrbWFodjVk&utm_source=qr"
  },
  stats: [
    { label: "NO", value: "COST EMI Options" },
    { label: "2000+", value: "Satisfied Travelers" },
    { label: "20+", value: "Destinations" },
    { label: "2 Yrs+", value: "Experience" }
  ]
};
